import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import marketingCodeUtil from '@sparta.auto-loans.utilities/marketing-code-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import InputUtility from '@sparta.sales.utilities/input-utility/dist/es6.js';
import { textInput } from '@sparta.global.helpers/text-inputs-helper/dist/es6.js';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <form id=\"zipCodeGroupForm\" action=\"javascript:void(0);\" novalidate=\"\">\r\n    <div class=\"row dtZipContainer\">     \r\n      <div class=\"column small-12 medium-6 zipInput\">\r\n        <div class=\"zipFieldDiv\">"
    + ((stack1 = (lookupProperty(helpers,"textInput")||(depth0 && lookupProperty(depth0,"textInput"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"zipCodeField") : depth0),{"name":"textInput","hash":{},"data":data,"loc":{"start":{"line":6,"column":33},"end":{"line":6,"column":61}}})) != null ? stack1 : "")
    + "</div>\r\n      </div>\r\n      <div class=\"column small-12 medium-6 dealerbutton\">\r\n        <span>"
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"LINKS") : depth0)) != null ? lookupProperty(stack1,"dtShopforCar") : stack1),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":9,"column":14},"end":{"line":9,"column":45}}})) != null ? stack1 : "")
    + "</span>\r\n      </div>\r\n      <div class=\"zipTitle\">\r\n        <p class=\"shopText\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"note") || (depth0 != null ? lookupProperty(depth0,"note") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"note","hash":{},"data":data,"loc":{"start":{"line":12,"column":28},"end":{"line":12,"column":38}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n      </div>\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"promo") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":6},"end":{"line":18,"column":13}}})) != null ? stack1 : "")
    + "    </div>\r\n  </form>\r\n";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"column\">\r\n          <p class=\"promo\">"
    + ((stack1 = ((helper = (helper = lookupProperty(helpers,"promo") || (depth0 != null ? lookupProperty(depth0,"promo") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"promo","hash":{},"data":data,"loc":{"start":{"line":16,"column":27},"end":{"line":16,"column":38}}}) : helper))) != null ? stack1 : "")
    + "</p>\r\n        </div>\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"data1") : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":0},"end":{"line":21,"column":9}}})) != null ? stack1 : "")
    + "\r\n\r\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.auto-loans.modules/dt-zipcode-button-auto-unauth-module",
  "version": "3.0.0",
  "id": "dtZipcodeButtonAutoUnAuthModule",
  "containerID": "autoLoansDtZipcodeButtonAutoUnauthModule",
  "moduleName": "auto-loans-dt-zipcode-button-auto-unauth-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "dt-zipcode-button-auto-unauth-module",
  "data": {
    "init": "dtZipcodeButtonAutoUnAuthModuleJS",
    "options": {
      "var1": 1
    }
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        textInput,
        link,
        button
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    textInput,
    link,
    button
  },
  "dependencies": {
    "@sparta.auto-loans.utilities/marketing-code-utility": "^1.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/sparta-helper": "^1.0.0",
    "@sparta.global.helpers/text-inputs-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-events-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.1.5",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.sales.utilities/input-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class dtZipcodeButtonAutoUnAuthModuleJS
 * @extends {Module}
 */
class dtZipcodeButtonAutoUnAuthModuleJS extends Module {
  /**
   * Creates an instance of dtZipcodeButtonAutoUnAuthModuleJS.
   * @param {Object} options Module options
   * @param {Object} context Module context
   * @memberof dtZipcodeButtonAutoUnAuthModuleJS
   */
  constructor(options, context) {
    super({
      ...options,
      target: '.dt-zipcode-button-auto-unauth-module',
      context,
      config: _moduleConfig
    });
    this.$module = this.settings.$target;
  }

  /**
   * @return {void}
   */
  init() {
    this.zipFieldLabel = document.querySelector('.zipFieldDiv').querySelector('.spa-input-label');
    this.zipFieldInput = document.querySelector('#zipCodeField');
    this.shopNowBtn = document.getElementById('shopNowButton');
    this.zipError = document.querySelector('#zipCodeField_errorMessage');
    this.errorMessage = 'Please enter a valid ZIP code.';
    this.spaErrorFormLabel = 'spa-error-form-label--validation';
    this.spaErrorFormInput = 'spa-error-form-input--validation';
    // Custom validation to fire on blur when zip field is blank,
    // contains any character that is not a digit, or is less than 5
    // Different than Sparta validations, but we still fire those as a catch all
    this.zipFieldInput.addEventListener('blur', () => {
      const zipVal = this.zipFieldInput.value.replace(/[^0-9]+/g, '');
      if (zipVal && zipVal.length === 5) {
        this.zipError.textContent = '';
        this.zipFieldLabel.classList.remove(this.spaErrorFormLabel);
        this.zipFieldInput.classList.remove(this.spaErrorFormInput);
      } else if (zipVal.length > 5) {
        const zipVal5digit = zipVal.substring(0, 5);
        this.zipFieldInput.value = zipVal5digit;
      } else {
        this.zipError.textContent = this.errorMessage;
        this.zipFieldLabel.classList.add(this.spaErrorFormLabel);
        this.zipFieldInput.classList.add(this.spaErrorFormInput);
      }
      InputUtility.applySpartaInputValidation(this.$module);
    });

    // If authenticated, grab user profile zip code and append to shopNowButton
    if (spaParams.siteName === 'secure-auto-loans') {
      spartaEventsUtility.sub('secure-auto-loans-profile-ready', ({
        data
      }) => {
        const profile = data;
        const customerData = profile.customer;

        // pull customers zip code from profile, take first 5 numbers,
        // and apply as parameter to the "Select your Car" URLs
        let zipCode5digit = '';
        const zipCode = {
          ...customerData
        };
        const profileState = customerData.state;
        const militaryState = ['AA', 'AE', 'AP'].includes(profileState);
        if (typeof zipCode === 'string') {
          zipCode5digit = zipCode.substring(0, 5);
        }
        if (profileState && zipCode5digit.length === 5 && militaryState === false) {
          this.zipFieldInput.value = zipCode5digit;
        }
      }, true);
    }
    document.getElementById('zipCodeGroupForm').addEventListener('submit', e => {
      e.preventDefault();
      let zipVal = this.zipFieldInput.value;
      zipVal = zipVal.replace(/[^0-9]+/g, '');
      if (zipVal && zipVal.length === 5) {
        this.zipError.textContent = '';
        this.zipFieldLabel.classList.remove(this.spaErrorFormLabel);
        this.zipFieldInput.classList.remove(this.spaErrorFormInput);
        this.sendURL(zipVal);
        spartaUILayersUtility.openLayer($('#modalLayerLeavingContent'));
      } else {
        this.zipError.textContent = this.errorMessage;
        this.zipFieldLabel.classList.add(this.spaErrorFormLabel);
        this.zipFieldInput.classList.add(this.spaErrorFormInput);
      }
    });
  }

  /**
   * @param {number} zipCode number
   * @return {void}
   */
  sendURL(zipCode) {
    // Set "shop for your car" button to pull dealer track path based on environment
    this.shopNowBtn.setAttribute('href', spaParams.siteParams.dealerTrack);

    // Append zip code to dealertrack URL to pass in the value
    const shopInterstitialPath = this.shopNowBtn.getAttribute('href');
    const delim = shopInterstitialPath.indexOf('?') > -1 ? '&' : '?';
    this.shopNowBtn.setAttribute('href', `${shopInterstitialPath}${delim}geoZip=${zipCode}`);

    // If marketing code is passed, grab code from URL and append to shop for your car button
    marketingCodeUtil.appendMarketingCode(this.shopNowBtn);
  }
}
registerModuleClass({
  moduleClass: dtZipcodeButtonAutoUnAuthModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { dtZipcodeButtonAutoUnAuthModuleJS as default, moduleConfig };
